import React,{useState} from 'react';
import "../styles/Student.css";



const StudentPage = () => {
    const[isBtnClicked,setIsBtnClicked] = useState(false);
    function searchStudentById(){
        setIsBtnClicked(true);
    }
    function closeStudentDetails(){
        setIsBtnClicked(false);
    }
    const StudentDetails = ()=>{
        return(<>
            <div className="card studentDetailsCard">
                <div className="card-body">
                    <div className="card-content">
                        <h6>Personal Details</h6>
                        <p className="mt-4">Name : Goutham Kumar</p>
                        <p>Father name : Srinivas</p>
                        <p>DoB : 03/06/2001</p>
                        <p>Present Class : 10th standard</p>
                        {/* <p>Present Class : 10th standard</p> */}
                        <hr/>
                        <h6>Fee Details</h6>
                        <p className="mt-4">Total Fee : 15,000/-</p>
                        <p>Paid : 10,000/-</p>
                        <p>Remaining : 5,000/-</p>
                    </div>
                </div>
                <button className="closeDetailsBtn btn btn-md btn-warning"
                onClick={closeStudentDetails}>close</button>
            </div>
        </>);
    }
    return (
    <div className="mainDivStudentPage">
       {!isBtnClicked ? <>
        <div className="card px-5">
        <div className="card-body px-5">
            <p className="text text-center">Search for student</p>
            <input type="text" placeholder="Enter student admission number" className="form-control studentAdmissionIdInput"/>
            <div className="searchBtnContainer">
            <button className="my-3 btn btn-md btn-outline btn-success searchBtn"
            onClick={searchStudentById}>Search now</button>

            </div>
        </div>
       </div>
       </>:<>
        <StudentDetails/>
       </>}
    </div>
  )
}

export default StudentPage